// extracted by mini-css-extract-plugin
module.exports = {"this":"styles_this__2BuNz","icon":"styles_icon__1odM6"};